import { useState, useEffect } from 'react'
import { getModuleBacklink, clearModuleBacklink, backToProject } from '../lib/moduleLink.js'

// Zeigt "← Zurück zum Projekt …" oberhalb des Modul-Inhalts, wenn der User
// aus einer Projekt-Detailansicht in ein Modul gesprungen ist. Verschwindet,
// sobald eine andere Seite geöffnet wird.
export default function ModuleBacklinkBar({ page }) {
  const [backlink, setBacklink] = useState(null)

  useEffect(() => {
    const bl = getModuleBacklink()
    if (bl && bl.page === page) {
      setBacklink(bl)
    } else {
      if (bl) clearModuleBacklink() // Seite gewechselt → Rückweg verfällt
      setBacklink(null)
    }
  }, [page])

  if (!backlink) return null
  const label = [backlink.project_number, backlink.project_name].filter(Boolean).join(' ') || 'Projekt'
  return (
    <button
      onClick={() => backToProject(backlink.project_id, backlink.origin_tab)}
      style={{
        display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10,
        padding: '6px 12px', border: '1px solid var(--color-border-light)', borderRadius: 6,
        background: 'var(--color-bg-subtle, #f5f5f5)', color: 'var(--color-text)', cursor: 'pointer',
        fontSize: 13, alignSelf: 'flex-start',
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
      Zurück zum Projekt {label}
    </button>
  )
}
